import { rest } from 'utils';

export default {
  getProfile: () => rest.get({ baseUrl: 'billing', url: '/profile' }),
  getProducts: ({ contractId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/products` }),
  getUsage: ({ contractId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/usage` }),
  getUsageByDatacenter: ({ contractId, datacenterId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/usage/${datacenterId}` }),
  getInvoices: ({ contractId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/invoices` }),
  getInvoicesById: ({ contractId, invoiceId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/invoices/${invoiceId}` }),
  getInvoicesByPeriod: ({ contractId, period }) => rest
    .get({ baseUrl: 'billing', url: `/invoices/${period}${contractId ? `?contractid=${contractId}` : ''}` }),
  getTraffic: ({ contractId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/traffic` }),
  getTrafficByPeriod: ({ contractId, period }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/traffic/${period}` }),
  getEvn: ({ contractId }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/evn` }),
  getEvnByPeriod: ({ contractId, period }) => rest.get({ baseUrl: 'billing', url: `/${contractId}/evn/${period}` }),
};
